import React, { useState, useEffect } from "react";
import { Field } from "formik";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import Loading from "../utils/loader";
import { deviceType } from "../../utils/registrationUtils";

const CareersRegisterInterestedIn = (props) => {
  const {
    values,
    setFieldValue,
    errors,
    touched,
    domain,
    setTouched
  } = props;
  const [updatedCheckboxArray, setUpdatedCheckboxArray] = useState([1,2]);

  useEffect(() => {
      if(domain?.id == 2 && values?.interested_in?.length == 0){
        setFieldValue("area_of_interest", []);
        setTouched({
            ...props.touched,
            ...{ "area_of_interest": false }
          })
        props.setSelectedAreaOfInterestValues([]);
      }
  },[values?.interested_in])
  
  return (
    <div className="careers_register_passport">
      {props.interestedInLoading ? <Loading />
        :
        <>
          <p>{props.placeholder}</p>
          <div className="careers_register_interested_card">
            {props.interestedInCheckbox?.map((obj) => {
              return (
                <span className="careers_register_custom_checkbox">
                  <Field
                    type="checkbox"
                    name={props.name}
                    id={`int_${obj.preference_id}`}
                    // value={obj.preference_id}
                    value={props.values?.[props?.name] ? props.values?.[props?.name] : {}}
                    checked={obj.selected}
                    onChange={(item, id) => {
                      props.handleInterestedCheckbox(item, obj.preference_id);
                      if(props.domain?.id == 2){ //to be done only for certification domain
                        let newArray = [...updatedCheckboxArray];
                        if (item.target.checked) {
                          newArray.push(obj.preference_id);
                        } else {
                          newArray = newArray.filter((id) => id !== obj.preference_id);
                        }

                        setUpdatedCheckboxArray(newArray);
                          props.areaOfInterestApiCall(undefined, [...new Set(newArray)], undefined, undefined);
                        if(window.location.pathname?.includes("/user/update-profile")){
                          props.postUpdateProfileOnChange(undefined, [...new Set(newArray)], undefined, undefined, false);
                            props.setFormikValues((prev) => ({...prev, "interested_in": [...new Set(newArray)]}))
                        }
                        
                      if (obj.preference_id == 2) {
                        props.setFieldValue("certificate_interest", null)
                        props.setTouched({
                          ...props.touched,
                          ...{ "certificate_interest": false }
                        })
                      }
                      if (obj.preference_id == 1) {
                        props.setFieldValue("education_interest", null)
                        props.setTouched({
                          ...props.touched,
                          ...{ "education_interest": false }
                        })
                      }}
                    }}
                  />
                  <label className="careers_register_interested_label" htmlFor={`int_${obj.preference_id}`}>{obj.value}</label>
                </span>
              );
            })}
          </div>
          {
             props.fieldErrors?.[props.name] && (
              <div className={deviceType == "mobile" ? "interested_in_invalid_card" : "invalid_card"}>
                <span className="invalid_card_text">{props.errors?.[props.name]}</span>
              </div>
              )
            }
        </>}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    interestedInLoading: state.userSignUpFields.interestedInLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CareersRegisterInterestedIn);

